import { Tree, TreeNode } from "react-organizational-chart";
import styled from "styled-components";
import CustomerIcon from '@enerex/unified-ui-react/icons/CustomerIcon'; // fallback icon
import { buildCompanyLogoUrl } from "utils/logo";   
import { Link } from "react-router-dom"; // add this at the top

const NodeBox = styled.div`
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid ${({ $current }) => ($current ? "#2ecc71" : "#999")};
  background: ${({ $current }) => ($current ? "#eafaf1" : "#fff")};
  font-size: 12px;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;

// Label component with logo
const CompanyLabel = ({ node }) => {
  const logo_error = (e) => {
    const target = e.target;
    target.style.display = "none";
    if (target.nextSibling) {
      target.nextSibling.style.display = "inline-block";
    }
  };

  return (
    <NodeBox $current={node.isCurrent}>
      {node.domain ? (
        <>
          <img
            src={buildCompanyLogoUrl(node.domain)}
            alt={node.name}
            onError={logo_error}
            style={{ width: 18, height: 18, objectFit: "contain", borderRadius: 3 }}
          />
          <CustomerIcon fontSize={18} style={{ display: "none" }} />
        </>
      ) : (
        <CustomerIcon fontSize={18} />
      )}
      <Link
        to={`/companies/${node.id}`}
        target="_blank"
        style={{ textDecoration: "none", color: "#000", fontWeight: 500, marginLeft: 4 }}
      >
        {node.name}
      </Link>    
    </NodeBox>
  );
};

// Recursive node renderer
const renderNode = (node) => {
  if (!node) return null;

  return (
    <TreeNode key={node.id} label={<CompanyLabel node={node} />}>
      {Array.isArray(node.children) &&
        node.children.map((child) => renderNode(child))}
    </TreeNode>
  );
};

export default function CompanyHierarchyTree({ data }) {
  if (!data) return null;

  return (
    <Tree
      lineWidth="2px"
      lineColor="#ccc"
      lineBorderRadius="6px"
      label={<CompanyLabel node={data} />}
    >
      {Array.isArray(data.children) &&
        data.children.map((child) => renderNode(child))}
    </Tree>
  );
}
